export default "__VITE_ASSET__xNFy7_Re__"